<template>
  <div class="relative">
    <div class="absolute inset-0 flex items-center" aria-hidden="true">
      <div class="w-full border-t border-gray-300"/>
    </div>
    <div class="relative flex justify-center">
      <button type="button" @click="$emit('btnClick')"
              class="inline-flex items-center shadow-sm px-4 py-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
        <PlusSmIcon class="-ml-1.5 mr-1 h-5 w-5 text-gray-400" aria-hidden="true"/>
        <span>{{ btnText }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import {PlusSmIcon} from '@heroicons/vue/solid'

export default {
  emits: ['btnClick'],
  props: {
    btnText: {
      default: 'Добавить'
    }
  },
  components: {
    PlusSmIcon,
  },
}
</script>